import App from "./App/navigation";
import "./App.css";

export default App;
